import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type GlobalIssueCreateModernisedModalEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const globalIssueCreateModernisedModalEntryPoint: EntryPoint<
	GlobalIssueCreateModernisedModalEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<GlobalIssueCreateModernisedModalEntryPointComponent>(
		/* webpackChunkName: "jira-global-issue-create-modernised-modal-entrypoint" */ './IssueCreateModalEntryPoint.tsx',
	),
	getPreloadProps: () => ({}),
});
